import Checkmark from './src/checkmark-combined';
export default Checkmark;